import { render, staticRenderFns } from "./TransactionManagement.vue?vue&type=template&id=0f12b9b8&scoped=true"
import script from "./TransactionManagement.vue?vue&type=script&lang=ts"
export * from "./TransactionManagement.vue?vue&type=script&lang=ts"
import style0 from "./TransactionManagement.vue?vue&type=style&index=0&id=0f12b9b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12b9b8",
  null
  
)

export default component.exports